import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import ImageLoader from 'react-render-image';
import { Icon } from '../Icon';
import { IconEmptyWrapper, IconPositionWrapper, IconTitleWrapper, IconWrapper, EmojiWrapper } from './styled';
import LinkIcon from '@atlaskit/icon/glyph/link';
export var IconAndTitleLayout = /*#__PURE__*/function (_React$Component) {
  _inherits(IconAndTitleLayout, _React$Component);
  var _super = _createSuper(IconAndTitleLayout);
  function IconAndTitleLayout() {
    _classCallCheck(this, IconAndTitleLayout);
    return _super.apply(this, arguments);
  }
  _createClass(IconAndTitleLayout, [{
    key: "renderAtlaskitIcon",
    value: function renderAtlaskitIcon() {
      var _this$props = this.props,
        icon = _this$props.icon,
        emoji = _this$props.emoji;
      if (emoji) {
        return /*#__PURE__*/React.createElement(EmojiWrapper, null, emoji);
      }
      if (!icon || typeof icon === 'string') {
        return null;
      }
      return /*#__PURE__*/React.createElement(IconWrapper, null, icon);
    }
  }, {
    key: "renderImageIcon",
    value: function renderImageIcon(errored, testId) {
      var url = this.props.icon;
      if (!url || typeof url !== 'string') {
        return null;
      }
      return /*#__PURE__*/React.createElement(ImageLoader, {
        src: url,
        loaded: /*#__PURE__*/React.createElement(Icon
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
          className: "smart-link-icon",
          src: url,
          "data-testid": "".concat(testId, "-image")
        }),
        errored: errored
      });
    }
  }, {
    key: "renderIconPlaceholder",
    value: function renderIconPlaceholder(testId) {
      var defaultIcon = this.props.defaultIcon;
      if (defaultIcon) {
        return /*#__PURE__*/React.createElement(IconWrapper, null, defaultIcon);
      }
      return /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(LinkIcon, {
        label: "link",
        size: "small",
        testId: "".concat(testId, "-default")
      }));
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(testId) {
      // We render two kinds of icons here:
      // - Image: acquired from either DAC or Teamwork Platform Apps;
      // - Atlaskit Icon: an Atlaskit SVG;
      // Each of these are scaled down to 12x12.
      var icon = this.renderAtlaskitIcon();
      if (icon) {
        return icon;
      }
      var placeholder = this.renderIconPlaceholder(testId);
      var image = this.renderImageIcon(placeholder, testId);
      return image || placeholder;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        children = _this$props2.children,
        title = _this$props2.title,
        titleColor = _this$props2.titleColor,
        _this$props2$testId = _this$props2.testId,
        testId = _this$props2$testId === void 0 ? 'media-inline-card-icon-and-title' : _this$props2$testId;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconTitleWrapper
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      , {
        style: titleColor ? {
          color: titleColor
        } : undefined
      }, /*#__PURE__*/React.createElement(IconPositionWrapper, null, children || /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconEmptyWrapper, null), this.renderIcon(testId))), /*#__PURE__*/React.createElement("span", {
        "data-test-id": "title"
      }, title)));
    }
  }]);
  return IconAndTitleLayout;
}(React.Component);